<template>
    <div class="sideBar">
        <div class="sideBarTop">
            <div class="HSpace1"></div>
            <!-- <div class="headImg"><img src="../../assets/index/logo_home.png"  alt=""></div> -->
            <p class="hello flex flex-align-center flex-pack-center">Hello,</p>
            <p class="storeName flex flex-align-center flex-pack-center" v-text="storeData.name"></p>
            <div  class="changeStore flex flex-align-center flex-pack-center">
                <i class="iconfont icon-qihuan"></i><router-link tag="span" to="/store" replace>切换店铺</router-link>
            </div>
        </div>
        <div class="navMenu">
            <ul class="menuList">
                <li v-for="(item,ind) in sideBarData" :class="{
                    isOpen1:(item.isOpen&&item.son.length==1&&btn),
                    isOpen2:(item.isOpen&&item.son.length==2&&btn),
                    isOpen3:(item.isOpen&&item.son.length==3&&btn), 
                    isOpen401:(item.isOpen&&item.son.length==4&&btn), 
                    isOpen402:(item.isOpen&&item.son.length==5&&btn), 
                    isOpen403:(item.isOpen&&item.son.length==6&&btn), 
                    isOpen404:(item.isOpen&&item.son.length==7&&btn), 
                    isOpen405:(item.isOpen&&item.son.length==8&&btn), 
                    isOpen403_:(item.isOpen&&item.fixedSon&&btn), 
                    'title-active':item.isOpen}" class="subMenu"
                    >
                    <div class="subMenuTitle flex flex-align-center" @click="handle(item,ind)">
                        <i :class="item.iconClass"></i>
                        <span v-text="item.name"></span>
                    </div>
                    <ul class="subSonMenu" v-if="item.son.length">
                        <router-link tag="li" class="menuItem" v-for="(son,sonInd) in item.son" :to="son.routeName" :active-class="'son-active'" :key = "sonInd">
                            <span class="menuItemSpan" v-text="son.name"></span>
                        </router-link>
                        <li class="menuItem" v-for="(fixedSonItem,fixedSonItemInd) in item.fixedSon" @click="goInv">
                            <span class="menuItemSpan" v-text="fixedSonItem.name"></span>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['storeData'],
    	data () {
    		return {
                btn:true,
                sideBarData: [
                //    {
                //         name:"交易趋势",
                //         iconClass: "iconfont icon-shouye",
                //         son:[
                           
                //         ],
                //         fixedSon:null,
                //         isOpen:false,
                //         routeName:`/sys/${this.$route.params.id}/Statement`,
                //         isActive:0, 
                //     },
                     {
                        name:"店铺报表",
                        iconClass: "iconfont icon-dianpufenxi",
                        son:[
                           
                        ],
                        isOpen:false,
                        routeName:`/sys/${this.$route.params.id}/statement`,
                        isActive:0, 
                    },
                    {
                        name:"员工管理",
                        iconClass: "iconfont icon-admin_man",
                        son:[
                            {name:'员工列表',routeName:`/sys/${this.$route.params.id}/employee`,isActive:0},
                            {name:'员工业绩',routeName:`/sys/${this.$route.params.id}/achievement`,isActive:0},
                            {name:'微信通知',routeName:`/sys/${this.$route.params.id}/wechatList`,isActive:0},
                            {name:'岗位设置',routeName:`/sys/${this.$route.params.id}/jobs`,isActive:false}
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:0, 
                    },
                    // {
                    //     name:"岗位管理",
                    //     iconClass: "iconfont icon-gangweibiandong",
                    //     son:[
                    //         {name:'岗位',routeName:`/sys/${this.$route.params.id}/jobs`,isActive:false}
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:'',
                    //     isActive:0, 
                    // },
                    {
                        name:"会员管理",
                        iconClass: "iconfont icon-huiyuanguanli",
                        son:[
                            // {name:'会员资料',routeName:`/sys/${this.$route.params.id}/vipMan`,isActive:false},
                            {name:'会员资料',routeName:`/sys/${this.$route.params.id}/lostVip/ALL`,isActive:false},
                            {name:'会员充值规则',routeName:`/sys/${this.$route.params.id}/vipRecharge`,isActive:false},
                            {name:'会员充值记录',routeName:`/sys/${this.$route.params.id}/chargeInfo`,isActive:false},
                            {name:'微信点单',routeName:`/sys/${this.$route.params.id}/wechatOrder`,isActive:false}
                        ],
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },{
                        name:"商品管理",
                        iconClass: "iconfont icon-shangpinguanli",
                        son:[
                            {name:'商品资料',routeName:`/sys/${this.$route.params.id}/goodsInfo`,isActive:false},
                            {name:'商品分类',routeName:`/sys/${this.$route.params.id}/goodsClassify`,isActive:false},
                            {name:'规格管理',routeName:`/sys/${this.$route.params.id}/spec`,isActive:false},
                            // {name:'排单机',routeName:`/sys/${this.$route.params.id}/bigScreenGoods`,isActive:false},
                            {name:'捕获率商品管理',routeName:`/sys/${this.$route.params.id}/catchRateGoods`,isActive:false},
                            {name:'销售时段管理',routeName:`/sys/${this.$route.params.id}/goodsInterval`,isActive:false},
                            {name:'商品变动记录',routeName:`/sys/${this.$route.params.id}/goodsLog`,isActive:false},
                        ],
                        fixedSon:[
                             {name:'库存管理'}
                        ],
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    // 
                    // 
                    {
                        name:"交易管理",
                        iconClass: "iconfont icon-shujufenxi",
                        son:[
                           {name:'对账单',routeName:`/sys/${this.$route.params.id}/dailyGrade`,isActive:false},
                           {name:'同期日报表(周)',routeName:`/sys/${this.$route.params.id}/ringReport`,isActive:false},
                           {name:'交接班记录',routeName:`/sys/${this.$route.params.id}/exchangeWork`,isActive:false},
                           {name:'班次销售统计',routeName:`/sys/${this.$route.params.id}/exchangeWorkNew`,isActive:false},
                        //    {name:'订单流水',routeName:`/sys/${this.$route.params.id}/orderSearch`,isActive:false},
                           {name:'销售汇总',routeName:`/sys/${this.$route.params.id}/totalSales`,isActive:false},
                           {name:'库存汇总',routeName:`/sys/${this.$route.params.id}/stockData`,isActive:false},
                           {name:'电子对账单',routeName:`/sys/${this.$route.params.id}/elecSales`,isActive:false},
                        //    {name:'采购汇总',routeName:`/sys/${this.$route.params.id}/stockSummary`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:0, 
                    },
                    // 
                    {
                        name:"机位管理",
                        iconClass: "iconfont icon-1",
                        son:[
                            {name:'机位设置',routeName:`/sys/${this.$route.params.id}/region`,isActive:false},
                            {name:'机位大屏',routeName:`/sys/${this.$route.params.id}/bigScreen`,isActive:false},
                            // {name:'机位设置',routeName:`/sys/${this.$route.params.id}/site`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    {
                        name:"原料管理",
                        iconClass: "iconfont icon-1",
                        son:[
                            {name:'原料单位',routeName:`/sys/${this.$route.params.id}/matUnit`,isActive:false},
                            {name:'原料商品',routeName:`/sys/${this.$route.params.id}/matGoods`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    {
                        name:"排队等号管理",
                        iconClass: "iconfont icon-1",
                        son:[
                            {name:'区域分类',routeName:`/sys/${this.$route.params.id}/regionType`,isActive:false},
                            {name:'排号管理',routeName:`/sys/${this.$route.params.id}/waitRegion`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    {
                        name:"配品管理",
                        iconClass: "iconfont icon-1",
                        son:[
                            {name:'配品列表',routeName:`/sys/${this.$route.params.id}/peiGoods`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    {
                        name:"活动管理",
                        iconClass: "iconfont icon-1",
                        son:[
                            {name:'第二份优惠',routeName:`/sys/${this.$route.params.id}/second`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false, 
                    },
                    // {
                    //     name:"库存管理",
                    //     iconClass: "iconfont icon-kucun",
                    //     son:[
                    //         {name:'商品入库',routeName:`/sys/${this.$route.params.id}/invAdd`,isActive:false},
                    //         {name:'入库记录',routeName:`/sys/${this.$route.params.id}/invList`,isActive:false},
                    //         {name:'库存详情',routeName:`/sys/${this.$route.params.id}/invDetails`,isActive:false}
                    //     ],
                    //     isOpen:false,
                    //     routeName:'',
                    //     isActive:false, 
                    // }, 
                    // 交易管理原始位置
                    // {
                    //     name:"原料商城",
                    //     iconClass: "iconfont icon-shangcheng",
                    //     son:[
                    //        {name:'原料商城',routeName:`/sys/${this.$route.params.id}/market`,isActive:false},
                    //        {name:'收货地址',routeName:`/sys/${this.$route.params.id}/address`,isActive:false},
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:'',
                    //     isActive:0, 
                    // },
                    
                    {
                        name:"优惠券管理",
                        iconClass: "iconfont icon-youhuiquan",
                        son:[
                            {name:'创建中心',routeName:`/sys/${this.$route.params.id}/addcoupon`,isActive:false},
                            // {name:'派发记录',routeName:`/sys/${this.$route.params.id}/couponDetail`,isActive:false},
                            {name:'核销统计',routeName:`/sys/${this.$route.params.id}/verifiCoupon`,isActive:false},
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:false,  
                    },
                    // {
                    //     name:"代金券管理",
                    //     iconClass: "iconfont icon-youhuiquanyouhuiquandaijinquan",
                    //     son:[
                    //         {name:'创建中心',routeName:`/sys/${this.$route.params.id}/voucher`,isActive:false},
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:'',
                    //     isActive:false,  
                    // },
                    // {
                    //     name:"商户资料",
                    //     iconClass: "iconfont icon-ecmerchants",
                    //     son:[
                    //        {name:'商户认证',routeName:`/sys/${this.$route.params.id}/merCert`,isActive:false},
                    //        // {name:'秘钥认证',routeName:`/sys/${this.$route.params.id}/keyCert`,isActive:false},
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:'',
                    //     isActive:0, 
                    // },
                    // {
                    //     name:"充值中心",
                    //     iconClass: "iconfont icon-xufei",
                    //     son:[
                           
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:`/sys/${this.$route.params.id}/topUp`,
                    //     isActive:0, 
                    // },
                    {
                        name:"下载中心",
                        iconClass: "iconfont icon-qrcode",
                        son:[
                           
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:`/sys/${this.$route.params.id}/createCode`,
                        isActive:0, 
                    },
                    {
                        name:"系统设置",
                        iconClass: "iconfont icon-set",
                        son:[

                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:`/sys/${this.$route.params.id}/setting`,
                        isActive:false,  
                    },
                    // {
                    //     name:"语音呼叫",
                    //     iconClass: "iconfont icon-yuyin",
                    //     son:[
                           
                    //     ],
                    //     fixedSon:null,
                    //     isOpen:false,
                    //     routeName:`/sys/${this.$route.params.id}/voiceCall`,
                    //     isActive:0, 
                    // }
                ]
    		}
    	},
        methods:{
            handle(item, ind) {
                if ( item.routeName ) {
                    //没有子导航类
                    this.$router.push(item.routeName);
                }
                if(this.sideBarData[ind].isOpen){
                    //点击有父类导航切换收拢打开。
                    this.btn = !this.btn;
                }else{
                    this.btn = true ;
                }
                for(var i = 0,len = this.sideBarData.length; i < len;i++){  
                   this.sideBarData[i].isOpen = false;
                }
                this.sideBarData[ind].isOpen = true;
            },
            //点击去库存管理
            goInv(){
                window.open('https://inventory.huoxingy.com/#/login');
            },
            noCall(value){
                switch(true){
                    case value == 'rewardInfo':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`)
                    break;
                    case value == 'getWithdraw':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`) 
                    break;
                    case value == 'putWithdraw':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`) 
                    break;
                    case value == 'setWithdraw':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`) 
                    break;
                    case value == 'ratingInfo':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`) 
                    case value == 'settleCount':
                    this.$router.push(`/sys/${this.$route.params.id}/Statement`) 
                    break;
                };
            }
        },
        created(){
            for(var i = 0; i < this.sideBarData.length;i++){
                if(this.sideBarData[i].son.length) {
                    for(var ii = 0; ii < this.sideBarData[i].son.length;ii++){
                        if(this.$route.fullPath.split(`${this.$route.params.id}/`)[1] == this.sideBarData[i].son[ii].routeName.split(`${this.$route.params.id}/`)[1]){
                            this.sideBarData[i].isOpen = true;
                        }
                    }
                }else {
                    if(this.$route.fullPath.split(`${this.$route.params.id}/`)[1] == this.sideBarData[i].routeName.split(`${this.$route.params.id}/`)[1]){
                        this.sideBarData[i].isOpen = true;
                    }
                }
            }
        },
        mounted() {
            // console.log(JSON.parse(sessionStorage.getItem("call")))
            // console.log(JSON.parse(sessionStorage.getItem("purchase")))
            if(JSON.parse(sessionStorage.getItem("call"))){
                let sideBarData = this.sideBarData;
                let callBar = {
                        name:"呼叫&打赏",
                        iconClass: "iconfont icon-dashang",
                        son:[
                           {name:'打赏记录',routeName:`/sys/${this.$route.params.id}/rewardInfo`,isActive:false},
                           {name:'评价记录',routeName:`/sys/${this.$route.params.id}/ratingInfo`,isActive:false},
                           {name:'提现记录',routeName:`/sys/${this.$route.params.id}/getWithdraw`,isActive:false},
                           {name:'我要提现',routeName:`/sys/${this.$route.params.id}/putWithdraw`,isActive:false},
                           {name:'设置提现信息',routeName:`/sys/${this.$route.params.id}/setWithdraw`,isActive:false},
                        //    {name:'语音软件下载',routeName:`/sys/${this.$route.params.id}/dlCall`,isActive:false}
                        ],
                        fixedSon:null,
                        isOpen:false,
                        routeName:'',
                        isActive:0, 
                    };
                sideBarData.splice(6,0,callBar);
                this.sideBarData = sideBarData;
            }else{
                this.noCall(this.$route.name);
            }
            setTimeout(()=>{
                if(JSON.parse(sessionStorage.getItem("isSettleCount"))){
                    let sideBarData = this.sideBarData;
                    for(let i=0;i<sideBarData.length;i++){
                        if(sideBarData[i].name == "交易管理"){
                            sideBarData[i].son.splice(1,0,
                                {name:'结算查询',routeName:`/sys/${this.$route.params.id}/settleCount`,isActive:false}
                            )
                        }
                    }
                    this.sideBarData = sideBarData;
                }else{
                    this.noCall(this.$route.name);
                }
            },500)
            
            setTimeout(()=>{
                if(JSON.parse(sessionStorage.getItem("purchase"))||this.storeData.purchaseEnabled){
                    let sideBarData = this.sideBarData;
                    let storeBar = {
                            name:"原料商城",
                            iconClass: "iconfont icon-shangcheng",
                            son:[
                            {name:'原料商城',routeName:`/sys/${this.$route.params.id}/market`,isActive:false},
                            {name:'收货地址',routeName:`/sys/${this.$route.params.id}/address`,isActive:false},
                            {name:'订单记录',routeName:`/sys/${this.$route.params.id}/orderInfo`,isActive:false},
                            ],
                            fixedSon:null,
                            isOpen:false,
                            routeName:'',
                            isActive:0, 
                        };
                    sideBarData.splice(7,0,storeBar);
                    this.sideBarData = sideBarData;
                }
                if(this.storeData.makeEnabled && this.storeData.makeEndTime && new Date(this.storeData.makeEndTime).getTime() > new Date().getTime()){
                    let sideBarData = this.sideBarData;
                    for(let i=0;i<sideBarData.length;i++){
                        if(sideBarData[i].name == "商品管理"){
                            sideBarData[i].son.splice(2,0,
                            {name:'排单机',routeName:`/sys/${this.$route.params.id}/bigScreenGoods`,isActive:false},
                            )
                        }
                    }
                    this.sideBarData = sideBarData;
                }
                // 
                try {
                    let leaseProductEnabled = sessionStorage.getItem("leaseProductEnabled");
                    if(leaseProductEnabled=="true"){
                        let sideBarData = this.sideBarData;
                        let menuBar = {
                            name:"租赁管理",
                            iconClass: "iconfont icon-zulin",
                            son:[
                                {name:'商品管理',routeName:`/sys/${this.$route.params.id}/rentGoods`,isActive:false},
                                {name:'租赁商品变动记录',routeName:`/sys/${this.$route.params.id}/goodsLogForRent`,isActive:false},
                                {name:'分类管理',routeName:`/sys/${this.$route.params.id}/rentCate`,isActive:false},
                                {name:'计费规则',routeName:`/sys/${this.$route.params.id}/rentRule`,isActive:false},
                                {name:'租赁明细',routeName:`/sys/${this.$route.params.id}/rentOrder`,isActive:false},
                                {name:'租赁汇总',routeName:`/sys/${this.$route.params.id}/rentDetail`,isActive:false},
                            ],
                            isOpen:false,
                            routeName:'',
                            isActive:false, 
                        }
                        sideBarData.splice(4,0,menuBar);
                        this.sideBarData = sideBarData;
                    }else{
                        let sideBarData = this.sideBarData;
                        let menuBar = {
                            name:"租赁管理",
                            iconClass: "iconfont icon-zulin",
                            son:[
                                {name:'联系开通',routeName:`/sys/${this.$route.params.id}/rentHello`,isActive:false},
                            ],
                            isOpen:false,
                            routeName:'',
                            isActive:false, 
                        }
                        sideBarData.splice(4,0,menuBar);
                        this.sideBarData = sideBarData;
                    }
                    this.$forceUpdate();
                } catch (error) {
                    console.log("error",error);
                }
                // 
            },500);
            
        },
    }
</script>
<style lang="scss">
    @import '../../../static/css/common.scss';
	@import "sideBar";
</style>



// WEBPACK FOOTER //
// sideBar.vue?4f730643